<div class="row mt-3">
  <div class="col-12 text-center">
    <h3 class="text-primary" translate>Current approval status</h3>
  </div>


  <div class="col-12 p-0">
    <div class="container-fluid p-xs-0">
      <div class="row justify-content-center menu-tab">
        <div class="col-md-11 col-xs-12 p-0">
          <ul class="nav nav-tabs nav-justified d-flex">

            <li class="nav-item">
              <div class="row">
                <div class="col-12 p-0">
                  <img src="../../assets/images/docStatus01_active.png" class="w-100">
                </div>
                <div class="col-12 p-0" style="margin-top: -5px;">
                  <img src="../../assets/images/statusPass.png" style="width: 30%;">
                </div>
                <div class="col-12 p-0">
                  <label translate>Upload documents</label>
                </div>
              </div>
            </li>

            <li class="nav-item">
              <img src="../../assets/images/line_active.png" class="w-100" style="height: 8%; margin-top: 45%;">
            </li>

            <li class="nav-item">
              <div class="row">
                <div class="col-12 p-0">
                  <img src="../../assets/images/docStatus02_active.png" class="w-100">
                </div>
                <div class="col-12 p-0" style="margin-top: -5px;">
                  <img src="../../assets/images/statusPass.png" style="width: 30%;">
                </div>
                <div class="col-12 p-0">
                  <label translate>Request for document examination at an agent bank.</label>
                </div>
              </div>
            </li>

            <li class="nav-item">
              <img src="../../assets/images/line_{{status > 1 ? 'active' : 'inactive'}}.png" class="w-100" style="height: 8%; margin-top: 45%;">
            </li>

            <li class="nav-item" *ngIf="status == 6">
              <div class="row">
                <div class="col-12 p-0">
                  <img src="../../assets/images/docStatus03_active.png" class="w-100">
                </div>
                <div class="col-12 p-0" style="margin-top: -5px;">
                  <img src="../../assets/images/statusPass.png" style="width: 30%;">
                </div>
                <div class="col-12 p-0">
                  <label translate>Revise documents</label>
                </div>
              </div>
            </li>

            <li class="nav-item" *ngIf="status == 6">
              <img src="../../assets/images/line_inactive.png" class="w-100" style="height: 8%; margin-top: 45%;">
            </li>

            <li class="nav-item">
              <div class="row">
                <div class="col-12 p-0">
                  <img src="../../assets/images/docStatus04{{status == 2 ? '_active' : ''}}.png" class="w-100">
                </div>
                <div class="col-12 p-0" style="margin-top: -5px;">
                  <img *ngIf="status == 2" src="../../assets/images/statusPass.png" style="width: 30%;">
                </div>
                <div class="col-12 p-0">
                  <label translate>Awaiting approval</label>
                </div>
              </div>
            </li>

            <li class="nav-item">
              <div class="h-100 justify-content-center">
                <img src="../../assets/images/line_inactive.png" class="w-100" style="height: 8%; margin-top: 45%;">
              </div>
            </li>

            <li class="nav-item">
              <div class="row">
                <div class="col-12 p-0">
                  <img src="../../assets/images/docStatus05.png" class="w-100">
                </div>
                <div class="col-12 p-0" style="margin-top: -5px;">
                  <!-- <img src="../../assets/images/statusPass.png" style="width: 30%;"> -->
                </div>
                <div class="col-12 p-0">
                  <label translate>Approved</label>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

</div>

<div class="row justify-content-center">
  <div class="col-9 p-3">
    <div class="row border rounded border-primary">
      <div class="col-12">
        <h5 class="text-primary">สถานะเอกสาร</h5>
      </div>
      <div class="col-12">
        <label class="text-primary">
          สถาบันคุ้มครองเงินฝาก (สคฝ.) {{statusText}}
        </label>
      </div>
      <div class="col-12">
        <label class="text-secondary">
          เมื่อวันที่ {{statusDate | thaidate: 'short'}}
        </label>
      </div>
      <br>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/status-document/status-document.component.html